var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCircleCheckedSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.33333C11.1267 2.33333 13.6667 4.87333 13.6667 8C13.6667 11.1267 11.1267 13.6667 8 13.6667C4.87333 13.6667 2.33333 11.1267 2.33333 8C2.33333 4.87333 4.87333 2.33333 8 2.33333ZM8 1C4.13333 1 1 4.13333 1 8C1 11.8667 4.13333 15 8 15C11.8667 15 15 11.8667 15 8C15 4.13333 11.8667 1 8 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42007 11.3732L3.58007 8.53322C3.36673 8.31988 3.52007 7.96655 3.8134 7.96655H4.7534C4.84007 7.96655 4.92673 7.99988 4.98673 8.06655L6.40673 9.48655C6.54006 9.61988 6.74673 9.61988 6.88006 9.48655L10.8867 5.47988C10.9467 5.41988 11.0334 5.37988 11.1201 5.37988H12.0601C12.3601 5.37988 12.5067 5.73988 12.2934 5.94655L6.88673 11.3732C6.7534 11.5065 6.54673 11.5065 6.4134 11.3732H6.42007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCircleCheckedSmall);
export default __webpack_public_path__ + "static/media/FBOCircleCheckedSmall.7145a725d8ea01f83f654849e8b355be.svg";
export { ForwardRef as ReactComponent };